<div class="chart-container flex flex-column gap-spacing-3xl pb-spacing-xs">
  <div #chartContainer class="chart-content"></div>

  <!-- Custom Legend -->
  <div class="chart-legend">
    @for (item of legendItems; track item) {
      <div class="legend-item">
        <div class="legend-indicator">
          <div class="legend-dot" [style.background-color]="item.color"></div>
        </div>
        <span class="legend-label body-small-medium">{{ item.label }}</span>
      </div>
    }
  </div>
</div>
